import { Toast } from "@shopify/polaris"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

export const RandomAppNameButton = ({ randomAppName }) => {
	const { t } = useTranslation()

	const [showClipboardToast, setShowClipboardToast] = useState(false)

	const copyRandomAppNameToClipboard = (appName) => {
		navigator.clipboard.writeText(appName)
		setShowClipboardToast(true)

		setTimeout(() => {
			setShowClipboardToast(false)
		}, 2000)
	}

	return (
		<>
			<span
				style={{
					display: "inline-flex",
					gap: "0.3rem",
					alignItems: "center",
					padding: "0.2rem 0.4rem",
					background: "#fff",
					borderRadius: "1rem",
					border: "1px solid #ccc",
					boxShadow:
						"0 1px 1px rgba(0,0,0,0.1), 0 2px 2px rgba(0,0,0,0.1)",
					cursor: "pointer",
				}}
				onClick={() => copyRandomAppNameToClipboard(randomAppName)}
			>
				<span>{randomAppName}</span>
				<svg
					style={{ color: "#555", width: "0.7rem", height: "0.7rem" }}
					viewBox="0 0 16 16"
				>
					<g fill="currentColor">
						<path d="M9.5 0a.5.5 0 0 1 .5.5a.5.5 0 0 0 .5.5a.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5a.5.5 0 0 0 .5-.5a.5.5 0 0 1 .5-.5h3Z"></path>
						<path d="M3.5 1h.585A1.498 1.498 0 0 0 4 1.5V2a1.5 1.5 0 0 0 1.5 1.5h5A1.5 1.5 0 0 0 12 2v-.5c0-.175-.03-.344-.085-.5h.585A1.5 1.5 0 0 1 14 2.5v12a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-12A1.5 1.5 0 0 1 3.5 1Z"></path>
					</g>
				</svg>
			</span>

			{showClipboardToast && (
				<Toast
					content={t("common.copied_to_clipboard")}
					onDismiss={() => setShowClipboardToast(false)}
					duration={3000}
				/>
			)}
		</>
	)
}
